//@ts-nocheck
import { Box, useToast } from "@chakra-ui/react";
import React from "react";
import { useTutorApplicationFlow } from "../components/FormWrapper";
import { IRootStore } from "../stores";
import { STEPS } from "../stores/utils";
import { useTutorApplicationFlow as useVeriyTutorApplicationFlow } from "../components/VerificationWrapper";
import { AdapterType, ServerAdapterType } from "../adapter";
export function useClientSteps(step, store: IRootStore) {
  const { getFormWrapperProps: genericeGetFormWrapperProps } =
    useTutorApplicationFlow(store);
  const { getFormWrapperProps: identityGetFormWrapperProps } =
    useVeriyTutorApplicationFlow(store);
  const toast = useToast();
  function onError() {
    toast({
      title: `An error occured.`,
      status: "error",
      duration: 5000,
      isClosable: true,
      position: "top",
    });
  }

  async function onSubmitSection(formData: any, label = "") {
    let newStep = step;
    return store
      .onFormSubmit(formData, step, newStep)
      .then(() => {})
      .catch((error) => {
        onError();
        throw error;
      });
  }

  return {
    onError,
    onSubmitSection,
    getFormWrapperProps: [
      STEPS.VERIFICATION,
      STEPS.UPLOAD_WORK,
      STEPS.UPLOAD_EDUCATION,
    ].includes(step)
      ? identityGetFormWrapperProps
      : genericeGetFormWrapperProps,
  };
}

export const useSaveHook = (saveTutorInfo: (data: any) => Promise<any>) => {
  const toast = useToast();
  const [loading, setLoading] = React.useState(false);
  function onError() {
    toast({
      title: `An error occured.`,
      status: "error",
      duration: 5000,
      isClosable: true,
      position: "top",
    });
  }
  function onSuccess() {
    toast({
      title: `Saved successfully.`,
      status: "success",
      duration: 5000,
      isClosable: true,
      position: "top",
    });
  }
  async function onSubmitSection(formData: any) {
    try {
      setLoading(true);
      await saveTutorInfo(formData);
      onSuccess();
      setLoading(false);
    } catch (error) {
      console.log(error);
      onError();
      setLoading(false);
    }
  }
  return {
    loading,
    onSubmitSection,
  };
};
